module.exports = require("./es-BO.js");